import { DataContainer, Feature } from '@otto-ec/tracking-bct';

export type VariationTrackingData = {
    variationId: string;
    dataContainer: DataContainer;
    features: Feature[];
};

const EMPTY_DATA: VariationTrackingData = {
    variationId: '',
    dataContainer: {},
    features: [],
};

export class VariationTrackingDataProvider {
    private cache: VariationTrackingData = EMPTY_DATA;

    public set(variationId: string): void {
        this.cache = {
            variationId,
            dataContainer: { product_VariationId: [variationId] },
            features: this.buildFeatures(variationId),
        };
    }

    public getVariationTrackingData(): VariationTrackingData {
        return this.cache;
    }

    private buildFeatures(variationId: string): Feature[] {
        const productId = `product_${variationId}`;
        const businessDimensionId = `businessDimension_${variationId}`;
        return [
            { id: productId, name: 'Product', status: 'visible' },
            { id: businessDimensionId, parentId: productId, name: 'Business-Dimension', status: 'visible' },
            {
                id: variationId,
                parentId: businessDimensionId,
                variationId,
                name: 'Variation',
                status: 'visible',
            },
        ];
    }
}
